import { EGetFlatStatsActionType } from '../../actions/flatStats';
import { TReduxActions } from '../../types/redux';

const MOSCOW_REGION_ID = 1;

export function regionIdReducer(state: number = MOSCOW_REGION_ID, action: TReduxActions): number {
  switch (action.type) {
    case EGetFlatStatsActionType.Succeed:
      return action.payload.regionId;
  }

  return state;
}
